module.exports = __webpack_public_path__ + "static/img/12introduce.6cd23d60.jpg";